export default {
  unavailable: {
    title: 'Samoobsługowy dostęp partnera jest ograniczony',
    description:
      'Ta sekcja nie jest dostępna dla partnerów w trakcie onboardingu samoobsługowego. Skontaktuj się z menedżerem konta, jeśli jej potrzebujesz.',
  },
};
